module.exports = __webpack_public_path__ + "static/media/blog-4.d43c772e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-4.jpg
// module id = 845
// module chunks = 0